<div class="estimation-container">
  
  <ng-container *ngIf="loading; else mainContentTpl">
    <div style="width: 100%; flex: 1; min-height: 0; padding-right: 15px;">
      <app-terminal 
        style="display: block; height: 100%;"
        [text]="streamingText" 
        [title]="'Ejecutando Pipeline RAG...'" 
        [height]="'100%'">
      </app-terminal>
    </div>
  </ng-container>

  <ng-template #mainContentTpl>
    <div class="main-content">
      
      <div class="page-header unified-toolbar">
        <div class="toolbar-left" style="display: flex; align-items: center; gap: 15px;">
          <h1 class="cyber-title" style="margin: 0; display: flex; align-items: center; gap: 10px;">
            >_ TERMINAL DE SÍNTESIS RAG
          </h1>
          
          <div class="status-pill danger" *ngIf="hasExecutions">
              <span class="pulse-dot"></span> EN EJECUCIÓN (BLOQUEADO)
          </div>
          <div class="status-pill blocked" *ngIf="blockingWarningCode && !isHistoricalView && !isDiffMode" (click)="onOpenWarnings()" [appTooltip]="blockingWarningTooltip">
              <span class="pulse-dot"></span> SOLICITUD BLOQUEADA
          </div>
          <div class="status-pill warning" *ngIf="!hasExecutions && !canModifyEstimations">
              <span class="pulse-dot"></span> SOLO LECTURA
          </div>
          <div class="status-pill historical" *ngIf="isHistoricalView && !isDiffMode">
              <span class="pulse-dot"></span> MODO LECTURA HISTÓRICA
          </div>
          <div class="status-pill diff" *ngIf="isDiffMode">
              <span class="pulse-dot"></span> MODO AUDITORÍA (VS ACTUAL)
          </div>

          <app-status-pill-async></app-status-pill-async>
        </div>

        <div class="toolbar-right" style="display: flex; align-items: center; gap: 12px;">
          
          <button class="btn secondary" (click)="volverProyecto()">
            <svg viewBox="0 0 24 24"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
            VOLVER
          </button>

          <button class="btn secondary" *appHasPermission="'estimation:export'" [disabled]="!estimationSaved || isHistoricalView || isDiffMode || loading" (click)="openExportPanel()" title="Exportar las tareas del Borrador actual">
            <svg viewBox="0 0 24 24"><path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2v9.67z"/></svg>
            EXPORTAR
          </button>

          <button class="btn secondary" (click)="saveManualChanges()" [disabled]="isSavingDraft" *ngIf="estimationSaved && !hasExecutions && !isHistoricalView && canModifyEstimations">
            <svg *ngIf="!isSavingDraft" viewBox="0 0 24 24"><path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/></svg>
            <svg *ngIf="isSavingDraft" class="spinner-icon" viewBox="0 0 24 24"><path d="M12 2v4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8H2c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2z"/></svg>
            {{ isSavingDraft ? 'GUARDANDO...' : 'GUARDAR DRAFT' }}
          </button>

          <button class="btn secondary" (click)="togglePrompt()">
            <svg viewBox="0 0 24 24"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>
            {{ hasExecutions ? 'VER CONTEXTO' : '[ ] EDITAR CONTEXTO' }}
          </button>

        </div>
      </div>

      <div class="requirement-section" *ngIf="estimationSaved; else emptyStateTpl">
        
        <div class="section-header-flex">
            <h3 class="section-title">>_ Pipeline de Tareas Generadas</h3>
            
            <div style="display: flex; align-items: center; gap: 20px;">
                
                <app-estimation-quick-bar
                  *ngIf="!isHistoricalView && !isDiffMode"
                  [estimation]="selectedEstimation"
                  (openWarnings)="onOpenWarnings()">
                </app-estimation-quick-bar>

                <div class="toolbar-divider" *ngIf="historicalVersions.length > 0 && !isHistoricalView && !isDiffMode && canModifyEstimations"></div>

                <div class="diff-toggle-container" *ngIf="isHistoricalView && draftRequirementsBackup && canModifyEstimations">
                    <span class="diff-label">COMPARAR BORRADOR:</span>
                    <label class="switch">
                        <input type="checkbox" [(ngModel)]="isDiffMode" (change)="toggleDiff()">
                        <span class="slider round"></span>
                    </label>
                </div>
                
                <button class="btn warning sm" (click)="restoreVersion()" *ngIf="isHistoricalView && !hasExecutions && canModifyEstimations">
                    <svg viewBox="0 0 24 24"><path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/></svg>
                    RESTAURAR
                </button>

                <div class="version-control" *ngIf="historicalVersions.length > 0 && canModifyEstimations">
                    <select class="form-control version-selector" [(ngModel)]="viewingVersionId" [class.historical-active]="isHistoricalView" (change)="onVersionChange($event)">
                        <option value="actual">Versión: ACTUAL (Borrador)</option>
                        <option *ngFor="let v of historicalVersions" [value]="v.id">
                           [ Snapshot ] v{{ v.version }} - {{ v.creationdate | date:'dd/MM/yyyy HH:mm' }}
                        </option>
                    </select>
                </div>

                <span *ngIf="isDiffMode && !hasDiffChanges" class="no-diff-badge">
                   ( Esta versión es idéntica al borrador actual )
                </span>
                <div class="diff-legend" *ngIf="isDiffMode">
                    <span class="legend-item added">Nuevo</span>
                    <span class="legend-item removed">Eliminado</span>
                    <span class="legend-item modified">Modificado</span>
                </div>

            </div>
        </div>

        <app-estimation-warnings-panel
          *ngIf="!isHistoricalView && !isDiffMode && estimationSaved"
          [warnings]="selectedEstimation.metadata?.warnings || []"
          [expanded]="warningsPanelOpen"
          (closed)="onCloseWarnings()">
        </app-estimation-warnings-panel>

        <div class="table-scroll-area" [ngClass]="{'historical-mode': isHistoricalView && !isDiffMode, 'diff-mode': isDiffMode}">
          <table class="requirements-table">
            <colgroup>
              <col style="width: 30%">
              <col style="width: 9%">
              <col style="width: 15%">
              <col style="width: 9%">
              <col style="width: 15%">
              <col style="width: 11%">
              <col style="width: 11%">
              <col *ngIf="!hasExecutions && !isHistoricalView && canModifyEstimations" style="width: 4%">
            </colgroup>
            <thead>
              <tr>
                <th>Tarea / Requisito</th>
                <th>Tipo</th>
                <th>Subsistema</th>
                <th>Stack</th>
                <th>Perfil</th>
                <th style="text-align: center;">Horas</th>
                <th style="text-align: center;">Origen</th>
                <th *ngIf="!hasExecutions && !isHistoricalView && canModifyEstimations"></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let req of (isDiffMode ? diffRequirements : selectedEstimation.requirements)">
                
                <tr class="req-row" [ngClass]="'diff-' + req._diffStatus">
                  <td [attr.colspan]="hasExecutions || isHistoricalView || !canModifyEstimations ? 7 : 8" class="req-title">
                     <input type="text" class="inline-input req-input" 
                            [(ngModel)]="req.description" 
                            [disabled]="hasExecutions || isHistoricalView || isDiffMode || !canModifyEstimations" 
                            [style.text-decoration]="req._diffStatus === 'removed' ? 'line-through' : 'none'">
                  </td>
                </tr>

                <tr *ngFor="let t of req.tasks; let i = index" class="task-row"
                  [class.zebra-row]="i % 2 !== 0"
                  [ngClass]="['diff-' + t._diffStatus, t.confidence ? 'confidence-' + t.confidence.toLowerCase() : '']"
                  [attr.data-confidence]="t.confidence || null">
                  <td class="task-cell-first" style="vertical-align: top;">
                      <span *ngIf="t.confidence === 'LOW' || t.confidence === 'MEDIUM'"
                            class="confidence-badge"
                            [ngClass]="t.confidence.toLowerCase()"
                            [appTooltip]="t.confidence === 'LOW' ? 'Tarea con confianza baja. Estimación con incertidumbre alta — considera revisar el rango.' : 'Tarea con confianza media. Estimación razonable pero con margen de variación.'">
                        {{ t.confidence.charAt(0) }}
                      </span>
                      <div class="task-title-container">
                          <div class="task-title" style="display: flex; align-items: flex-start; gap: 5px;">
                              <span class="tree-line" style="margin-top: 6px;">|--</span> 
                              <div style="display: flex; flex-direction: column; gap: 2px; width: 100%;">
                                  <span *ngIf="isDiffMode && t._oldDescription !== undefined" class="diff-text-change">
                                      <span class="old-text">{{ t._oldDescription }}</span> ➔
                                  </span>
                                  <textarea class="inline-input task-textarea" rows="2"
                                            [(ngModel)]="t.description" 
                                            [disabled]="hasExecutions || isHistoricalView || isDiffMode || !canModifyEstimations" 
                                            (focus)="backupTask(t)" (change)="onTaskEdit(t)"
                                            [style.text-decoration]="t._diffStatus === 'removed' ? 'line-through' : 'none'">
                                  </textarea>
                              </div>
                          </div>
                      </div>
                  </td>

                  <td style="vertical-align: top;">
                      <div style="display: flex; flex-direction: column; gap: 2px;">
                          <span *ngIf="isDiffMode && t._oldType !== undefined" class="diff-text-change"><span class="old-text">{{ t._oldType || 'N/A' }}</span> ➔</span>
                          <input type="text" class="inline-input pill-input" [(ngModel)]="t.type" [disabled]="hasExecutions || isHistoricalView || isDiffMode || !canModifyEstimations" (focus)="backupTask(t)" (change)="onTaskEdit(t)">
                      </div>
                  </td>
                  <td style="vertical-align: top;">
                      <div style="display: flex; flex-direction: column; gap: 2px;">
                          <span *ngIf="isDiffMode && t._oldSubsystem !== undefined" class="diff-text-change"><span class="old-text">{{ t._oldSubsystem || 'N/A' }}</span> ➔</span>
                          <input type="text" class="inline-input" [(ngModel)]="t.subsystem" [disabled]="hasExecutions || isHistoricalView || isDiffMode || !canModifyEstimations" (focus)="backupTask(t)" (change)="onTaskEdit(t)">
                      </div>
                  </td>
                  <td style="vertical-align: top;">
                      <div style="display: flex; flex-direction: column; gap: 2px;">
                          <span *ngIf="isDiffMode && t._oldTechnology !== undefined" class="diff-text-change"><span class="old-text">{{ t._oldTechnology || 'N/A' }}</span> ➔</span>
                          <input type="text" class="inline-input pill-input" [(ngModel)]="t.technology" [disabled]="hasExecutions || isHistoricalView || isDiffMode || !canModifyEstimations" (focus)="backupTask(t)" (change)="onTaskEdit(t)">
                      </div>
                  </td>
                  <td style="vertical-align: top;">
                      <div style="display: flex; flex-direction: column; gap: 2px;">
                          <span *ngIf="isDiffMode && t._oldProfile !== undefined" class="diff-text-change"><span class="old-text">{{ t._oldProfile || 'N/A' }}</span> ➔</span>
                          <input type="text" class="inline-input" [(ngModel)]="t.profile" [disabled]="hasExecutions || isHistoricalView || isDiffMode || !canModifyEstimations" (focus)="backupTask(t)" (change)="onTaskEdit(t)">
                      </div>
                  </td>
                  
                  <td style="text-align: center; white-space: nowrap; vertical-align: top;">
                    <div class="hours-cell">
                      <span *ngIf="isDiffMode && t._oldHours !== undefined" class="diff-hours-change">
                          <span class="old-h">{{ t._oldHours }}H</span> ➔
                      </span>
                      <input type="number" class="inline-input text-center font-bold hours-input"
                             [(ngModel)]="t.estimatetime"
                             [disabled]="hasExecutions || isHistoricalView || isDiffMode || !canModifyEstimations"
                             (focus)="backupTask(t)" (change)="onTaskEdit(t)" min="0">
                      <app-task-range-bar
                        *ngIf="!isDiffMode && t.p10_hours !== undefined && t.p90_hours !== undefined"
                        [p10]="t.p10_hours"
                        [p50]="t.estimatetime"
                        [p90]="t.p90_hours"
                        [width]="60">
                      </app-task-range-bar>
                    </div>
                  </td>

                  <td style="text-align: center; vertical-align: top;">
                    <app-task-source-badge
                      [task]="t"
                      [opacity]="t._diffStatus === 'removed' ? 0.5 : 1">
                    </app-task-source-badge>
                  </td>

                  <td *ngIf="!hasExecutions && !isHistoricalView && canModifyEstimations" style="text-align: center; white-space: nowrap; vertical-align: top;">
                    <button *ngIf="t._isModified" class="btn-icon warning hover-only" (click)="undoTaskEdit(t)" title="Deshacer cambios">
                      <svg viewBox="0 0 24 24"><path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C20.48 11.03 16.84 8 12.5 8z"/></svg>
                    </button>
                    <button class="btn-icon primary hover-only" (click)="openEditTaskSlideOver(t)" title="Editar Tarea (Detalle)">
                      <svg viewBox="0 0 24 24"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>
                    </button>
                    <button class="btn-icon danger hover-only" (click)="deleteTask(req, i)" title="Borrar Tarea">
                      <svg viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
                    </button>
                  </td>
                </tr>

                <tr *ngIf="!hasExecutions && !isHistoricalView && canModifyEstimations" class="add-task-row">
                    <td [attr.colspan]="8" style="padding-left: 45px; padding-top: 5px; padding-bottom: 15px; border-bottom: none;">
                        <button class="btn secondary sm" (click)="addTask(req)">
                            + Añadir Tarea Manual
                        </button>
                    </td>
                </tr>
              </ng-container>

              <tr *ngIf="!hasExecutions && !isHistoricalView && canModifyEstimations" class="add-req-row">
                <td [attr.colspan]="8" style="padding: 15px; border-bottom: none; text-align: center;">
                  <button class="btn secondary sm" style="border-style: dashed;" (click)="addRequirement()">
                    + AÑADIR NUEVO REQUISITO
                  </button>
                </td>
              </tr>

              <tr class="total-row">
                <td colspan="5">
                  <div style="display: flex; align-items: center; font-weight: bold; font-size: 13px;">
                    <span *ngIf="lastExecutionTokens > 0" class="token-cost-badge" style="margin-right: 0;">
                      ⚡ Coste de síntesis: {{ lastExecutionTokens | number:'1.0-0' }} tokens
                    </span>
                    <span style="margin-left: auto;">SUMATORIO TOTAL:</span>
                  </div>
                </td>
                <td style="text-align: center; font-weight: bold; font-size: 15px;" 
                    [style.color]="isDiffMode && hasDiffChanges ? '#e2e8f0' : '#a6e22e'">
                  
                  <span *ngIf="isDiffMode && hasDiffChanges">
                     <span style="color: #6272a4; text-decoration: line-through; font-size: 12px;">{{ diffPastTotal }}H</span>
                     <span style="color: #a6e22e; margin-left: 5px;">{{ diffCurrentTotal }}H</span>
                  </span>
                  
                  <span *ngIf="!isDiffMode || !hasDiffChanges">{{ totalHoras }}H</span>
                </td>
                <td></td>
                <td *ngIf="!hasExecutions && !isHistoricalView && canModifyEstimations"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <ng-template #emptyStateTpl>
        <div class="empty-state">
          <div class="terminal-icon">
            <svg viewBox="0 0 24 24" width="48" height="48" opacity="0.3"><path fill="currentColor" d="M20 4H4c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.11-.9-2-2-2zm0 14H4V8h16v10zm-2-1h-6v-2h6v2zM5.5 13.5l-2-2L4.91 10 9 14l-4.09 4-1.41-1.5 2-2.5z"/></svg>
          </div>
          <p class="empty-text">>_ Esperando contexto para desplegar pipeline<span class="blink">_</span></p>
          <p class="empty-subtext">Edite el contexto arriba y pulse "Sintetizar con IA"</p>
        </div>
      </ng-template>

    </div>
  </ng-template>

  <div class="right-drawer" [class.collapsed]="!isSidebarOpen">
    <div class="drawer-trigger" (click)="toggleSidebar()">
      <svg viewBox="0 0 24 24" [style.transform]="!isSidebarOpen ? 'rotate(180deg)' : 'rotate(0deg)'">
        <path fill="currentColor" d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6z"></path>
      </svg>
      <span class="vertical-text" *ngIf="!isSidebarOpen">METADATA & STATUS</span>
    </div>

    <div class="drawer-body" *ngIf="isSidebarOpen">

      <div class="drawer-header"><span class="cyber-title">>_ CONTEXTO V3</span></div>

      <ng-container *ngIf="hasConfidenceAndBasisData">
        <div class="drawer-section">
          <h4 class="section-subtitle">Confianza y base</h4>
          <div class="token-data">
            <div class="token-row" *ngIf="projectTypeLabelLong">
              <span>
                Tipo de proyecto:
                <app-info-tooltip [text]="'Tipo de proyecto detectado por IA. Cambia la estrategia de descomposición y el porcentaje de contingencia.'"></app-info-tooltip>
              </span>
              <strong class="drawer-pill project-type-drawer">{{ projectTypeLabelLong }}</strong>
            </div>
            <div class="token-row" *ngIf="confidenceLabelLong">
              <span>
                Confianza:
                <app-info-tooltip [term]="'confidence'"></app-info-tooltip>
              </span>
              <strong class="drawer-pill" [ngClass]="confidenceClass">
                <span class="pulse-dot"></span>
                {{ confidenceLabelLong }}
              </strong>
            </div>
            <div class="token-row" *ngIf="basisLabelLong">
              <span>
                Base:
                <app-info-tooltip [term]="'basis'"></app-info-tooltip>
              </span>
              <strong class="drawer-pill basis-drawer">{{ basisLabelLong }}</strong>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="hasTotalsData">
        <hr class="drawer-divider">
        <div class="drawer-section">
          <h4 class="section-subtitle">Totales</h4>
          <div class="token-data">
            <div class="token-row" *ngIf="selectedEstimation?.rollup?.total_p50_hours !== undefined">
              <span>
                P50:
                <app-info-tooltip [term]="'p50'"></app-info-tooltip>
              </span>
              <strong>{{ selectedEstimation.rollup?.total_p50_hours }}H</strong>
            </div>
            <div class="token-row" *ngIf="selectedEstimation?.rollup?.contingency_buffer_hours !== undefined">
              <span>
                Contingencia:
                <app-info-tooltip [term]="'contingency'"></app-info-tooltip>
              </span>
              <strong class="value-warning">{{ selectedEstimation.rollup?.contingency_buffer_hours }}H</strong>
            </div>
            <div class="token-row" *ngIf="selectedEstimation?.rollup?.total_with_contingency_hours !== undefined">
              <span>
                Total con contingencia:
                <app-info-tooltip [term]="'total_with_contingency'"></app-info-tooltip>
              </span>
              <strong class="text-neon value-grand-total">{{ selectedEstimation.rollup?.total_with_contingency_hours }}H</strong>
            </div>
            <div class="token-row" *ngIf="(selectedEstimation?.rollup?.phantom_tasks_total_hours || 0) > 0">
              <span>
                Tareas preventivas:
                <app-info-tooltip [term]="'phantom_tasks'"></app-info-tooltip>
              </span>
              <strong>{{ selectedEstimation.rollup?.phantom_tasks_total_hours }}H</strong>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="hasWarningsInDrawer">
        <hr class="drawer-divider">
        <div class="drawer-section">
          <h4 class="section-subtitle">Avisos &middot; {{ drawerWarnings.length }}</h4>
          <ul class="drawer-warnings-list">
            <li *ngFor="let w of drawerWarnings"
                class="drawer-warning-item"
                [ngClass]="'severity-' + getWarningSeverity(w.code)"
                (click)="onOpenWarnings()">
              <span class="severity-dot"></span>
              <span class="warning-label">{{ getWarningLabel(w.code) }}</span>
            </li>
          </ul>
          <button class="btn secondary sm drawer-warnings-cta" (click)="onOpenWarnings()">
            Ver detalle
          </button>
        </div>
      </ng-container>

      <hr class="drawer-divider">
      <div class="drawer-section">
        <h4 class="section-subtitle">Consumo de IA</h4>
        <div class="token-data">
          <div class="token-row"><span>Tokens totales:</span> <strong>{{ tokensTotales | number:'1.0-0' }}</strong></div>
          <div class="token-row"><span>Tokens consumidos:</span> <strong class="value-danger">{{ tokensConsumidos | number:'1.0-0' }}</strong></div>
          <div class="token-row"><span>Tokens restantes:</span> <strong class="text-neon">{{ tokensRestantes | number:'1.0-0' }}</strong></div>
        </div>
      </div>

      <ng-container *ngIf="hasCalibrationData">
        <hr class="drawer-divider">
        <div class="drawer-section">
          <h4 class="section-subtitle">Calibración aplicada</h4>
          <div class="token-data">
            <div class="token-row" *ngIf="calibrationSummary?.samples_used !== undefined">
              <span>
                Muestras usadas:
                <app-info-tooltip [term]="'samples_used'"></app-info-tooltip>
              </span>
              <strong>{{ calibrationSummary?.samples_used }}</strong>
            </div>
            <div class="token-row" *ngIf="calibrationSummary?.median_calibration_ratio !== undefined">
              <span>
                Ratio mediano:
                <app-info-tooltip [term]="'calibration_ratio'"></app-info-tooltip>
              </span>
              <strong [ngClass]="calibrationRatioClass">×{{ calibrationSummary?.median_calibration_ratio | number:'1.2-2' }}</strong>
            </div>
            <div class="token-row" *ngIf="calibrationSummary?.phantom_tasks_detected !== undefined">
              <span>
                Tareas preventivas:
                <app-info-tooltip [term]="'phantom_tasks_detected'"></app-info-tooltip>
              </span>
              <strong>{{ calibrationSummary?.phantom_tasks_detected }}</strong>
            </div>
            <div class="token-row" *ngIf="calibrationSummary?.outliers_excluded !== undefined">
              <span>
                Outliers excluidos:
                <app-info-tooltip [term]="'outliers_excluded'"></app-info-tooltip>
              </span>
              <strong>{{ calibrationSummary?.outliers_excluded }}</strong>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="canViewDiagnostics && hasDiagnosticsData">
        <hr class="drawer-divider">
        <div class="drawer-section diagnostics-section">
          <h4 class="section-subtitle">Diagnóstico</h4>

          <div class="token-data">
            <div class="token-row" *ngIf="selectedEstimation?.metadata?.prompt_version">
              <span>
                Versión prompt:
                <app-info-tooltip [term]="'prompt_version'"></app-info-tooltip>
              </span>
              <strong class="mono-value">{{ selectedEstimation.metadata?.prompt_version }}</strong>
            </div>
            <div class="token-row" *ngIf="selectedEstimation?.metadata?.ai_assistance_observed_factor !== undefined">
              <span>
                Factor IA observado:
                <app-info-tooltip [term]="'ai_assistance_observed_factor'"></app-info-tooltip>
              </span>
              <strong>{{ selectedEstimation.metadata?.ai_assistance_observed_factor | number:'1.2-2' }}</strong>
            </div>
          </div>

          <div class="diagnostics-block" *ngIf="selectedEstimation?.metadata?.reasoning_trace">
            <div class="diagnostics-block-label">
              Reasoning trace
              <app-info-tooltip [term]="'reasoning_trace'"></app-info-tooltip>
            </div>
            <div class="reasoning-trace">{{ selectedEstimation.metadata?.reasoning_trace }}</div>
          </div>

          <div class="diagnostics-block" *ngIf="selfCheckItems.length > 0">
            <div class="diagnostics-block-label">
              Self-check
              <app-info-tooltip [term]="'self_check'"></app-info-tooltip>
            </div>
            <ul class="self-check-list">
              <li *ngFor="let item of selfCheckItems"
                  [ngClass]="item.value === true ? 'check-pass' : (item.value === false ? 'check-fail' : 'check-unknown')">
                <svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true">
                  <path *ngIf="item.value === true" fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                  <path *ngIf="item.value === false" fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                  <path *ngIf="item.value === undefined" fill="currentColor" d="M11 17h2v2h-2zm0-12h2v10h-2z"/>
                </svg>
                <span>{{ item.label }}</span>
              </li>
            </ul>
          </div>
          <div class="diagnostics-block" *ngIf="hasRollupDiscrepancy">
            <div class="diagnostics-block-label">
              Reconciliación de rollup
              <app-info-tooltip [term]="'rollup_reconciliation'"></app-info-tooltip>
            </div>
            <div class="token-data">
              <div class="token-row" *ngIf="originalP50 !== undefined">
                <span>Modelo declaró P50:</span>
                <strong>{{ originalP50 }}H</strong>
              </div>
              <div class="token-row" *ngIf="realP50 !== undefined">
                <span>Suma real P50:</span>
                <strong class="text-neon">{{ realP50 }}H</strong>
              </div>
              <div class="token-row" *ngIf="rollupDiff !== undefined">
                <span>Diferencia:</span>
                <strong [ngClass]="rollupDiffClass">{{ rollupDiff }}H</strong>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

    </div>
  </div>

  <app-export-panel
    [open]="isExportPanelOpen"
    [estimation]="selectedEstimation"
    [user]="user"
    (closed)="onExportPanelClosed()"
    (exported)="onExportSuccess($event)"
    (enqueued)="onExportEnqueued($event)"
    (failed)="onExportFailed($event)">
  </app-export-panel>

  <app-modal-estimation-wizard *ngIf="showModal" (close)="closeModal()"></app-modal-estimation-wizard>

  <app-slide-over 
    [open]="isPromptOpen" 
    [title]="'>_ CONTEXTO DE SÍNTESIS'" 
    [width]="'60%'" 
    (closed)="closePrompt()">
    
    <div class="slide-over-prompt-container">
      <p style="color: #a0aec0; font-size: 13px; margin: 0 0 15px 0;">
        Defina el alcance técnico, los flujos del sistema y cualquier restricción de arquitectura para que el modelo RAG analice la base de conocimiento y genere las tareas.
      </p>
      
      <textarea class="form-control cyber-prompt-slide"
                [(ngModel)]="selectedEstimation.prompt"
                [disabled]="hasExecutions || isHistoricalView || !canModifyEstimations"
                placeholder=">_ Escriba aquí el contexto..."></textarea>
      
      <div class="warning-text" *ngIf="hasExecutions" style="color: #ff5f56; font-size: 12px; margin-top: 10px; display: flex; align-items: center; gap: 5px;">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
        Pipeline en ejecución. No se puede re-estimar.
      </div>

      <div class="slide-over-actions" style="margin-top: 20px; display: flex; justify-content: flex-end; gap: 10px;">
          <button class="btn secondary" (click)="closePrompt()">CERRAR</button>
          <button class="btn primary btn-glow" 
                (click)="calculateEstimation()" 
                [disabled]="!isEditing || hasExecutions || isHistoricalView || !canModifyEstimations">
          <svg viewBox="0 0 24 24"><path d="M19 3h-1V1h-2v2h-1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-4V5h4v14zM7 10h2v7H7zm-4 3h2v4H3z"/></svg>
          SINTETIZAR CON IA
        </button>
      </div>
    </div>
  </app-slide-over>

  <app-slide-over
    [open]="isTaskEditSlideOverOpen"
    [title]="'>_ DETALLE Y EDICIÓN DE TAREA'"
    [width]="'520px'"
    (closed)="closeEditTaskSlideOver()">

    <div class="task-edit-container" *ngIf="editingTaskCopy">
      <p style="color: #a0aec0; font-size: 13px; margin: 0 0 15px 0;">
        Modifica los valores base de la tarea. Los metadatos vinculados a la inferencia RAG y la base vectorial de histórico son de solo lectura.
      </p>

      <div class="edit-section">
        <div class="form-group">
          <label>Descripción de la Tarea</label>
          <textarea class="form-control" rows="4" [(ngModel)]="editingTaskCopy.description"></textarea>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label>Tipo</label>
            <input type="text" class="form-control" [(ngModel)]="editingTaskCopy.type">
          </div>
          <div class="form-group">
            <label>Subsistema</label>
            <input type="text" class="form-control" [(ngModel)]="editingTaskCopy.subsystem">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label>Tecnología / Stack</label>
            <input type="text" class="form-control" [(ngModel)]="editingTaskCopy.technology">
          </div>
          <div class="form-group">
            <label>Perfil Requerido</label>
            <input type="text" class="form-control" [(ngModel)]="editingTaskCopy.profile">
          </div>
        </div>
        <div class="form-row">
            <div class="form-group">
                <label>Estimación P50 (Horas)</label>
                <input type="number" class="form-control" [(ngModel)]="editingTaskCopy.estimatetime" min="0">
            </div>
            <div class="form-group">
                </div>
        </div>
      </div>

      <div class="metadata-section">
        <h4 class="section-subtitle">Metadatos de Inferencia IA</h4>
        <div class="metadata-grid">
          <div class="meta-item"><span>Confianza IA:</span> <strong [ngClass]="editingTaskCopy.confidence ? 'confidence-' + editingTaskCopy.confidence.toLowerCase() : ''">{{ editingTaskCopy.confidence || 'N/A' }}</strong></div>
          <div class="meta-item"><span>Factor Asistencia IA:</span> <strong>{{ editingTaskCopy.ai_assistance_factor !== undefined ? editingTaskCopy.ai_assistance_factor : 'N/A' }}</strong></div>
          <div class="meta-item"><span>Rango P10:</span> <strong>{{ editingTaskCopy.p10_hours !== undefined ? editingTaskCopy.p10_hours + 'H' : 'N/A' }}</strong></div>
          <div class="meta-item"><span>Rango P90:</span> <strong>{{ editingTaskCopy.p90_hours !== undefined ? editingTaskCopy.p90_hours + 'H' : 'N/A' }}</strong></div>
          <div class="meta-item"><span>Origen:</span> <strong>{{ editingTaskCopy.source || 'N/A' }}</strong></div>
          <div class="meta-item"><span>Subtipo Origen:</span> <strong>{{ editingTaskCopy.source_subtype || 'N/A' }}</strong></div>
        </div>
        
        <div class="meta-item full-width" *ngIf="editingTaskCopy.analog_project_ids && editingTaskCopy.analog_project_ids.length > 0">
          <span>Proyectos Análogos Vinculados (Redis):</span>
          <div class="tag-list">
            <span class="meta-tag" *ngFor="let id of editingTaskCopy.analog_project_ids">{{ id }}</span>
          </div>
        </div>
      </div>

      <div class="slide-over-actions">
        <button class="btn secondary" (click)="closeEditTaskSlideOver()">CANCELAR</button>
        <button class="btn primary btn-glow" (click)="saveTaskEdit()">
          <svg viewBox="0 0 24 24"><path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3-3 3zm3-10H5V5h10v4z"/></svg>
          GUARDAR CAMBIOS
        </button>
      </div>
    </div>
  </app-slide-over>

</div>